export default "__VITE_ASSET__CRscGEZ6__"